<template lang="pug">
  div
    b-row
      .col-xl-10
        panel(:title='$t("ui.op_tournament")')
          b-card
            b-row.flex(slot="header")
              .col-sm-12.col-md-6.col-lg-8.col-xl-6.mb-1
                DatePicker
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.member_id')" size="sm")
                  DebounceInput(
                    type="text"
                    ref="member_id"
                    :placeholder='$t("ui.member_id")'
                    v-model="member_id"
                    size="sm"
                    @keyup.enter.native="submit"
                  )
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.d-flex
                SubmitButton.mr-2(:loading="loading" icon="fa fa-search" :text="$t('ui.search')" isModal=false type="button" @click="submit")
                .ml-auto
                  jsonToExcel(v-if="dailyWinloseList.length > 0" mode="Winlose" :date="dateRange")
            b-row.mb-2
              .col-sm-12.col-md-12.col-lg-12.col-xl-12
                b-breadcrumb.bg-grey-transparent-3.p-l-10
                  b-breadcrumb-item(
                    v-for="(item,index) in lines"
                    :key="index"
                    :text="item.account_id.toUpperCase()"
                    :class="{ active: index==lines.length-1 }"
                    :title="$helpers.getUplineName(item.account_type)"
                    @click="drillIn(item.account_id)"
                  )
            b-row
              .col-sm-12.col-md-8.col-lg-9.col-xl-10.mb-1
                b-pagination(size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" @input="submit")
              .col-sm-12.col-md-4.col-lg-3.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12
                b-table#tblList.table-sm.table-hover.table-bordered(striped show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="dailyWinloseList" :fields="fields" :per-page="perPage" :filter="filter" @sort-changed="sortingChanged")
                  template(v-slot:cell(index)="row")
                    span {{ row.index + 1 }}
                  template(v-slot:cell(account_id)="row")
                    b-link(@click="drillIn(row.item.account_id)" v-if="downlineLevel > 2") #[b {{ row.item.account_id.toUpperCase() }}]
                    span(v-else) #[b {{ row.item.account_id.toUpperCase() }}]
                  template(v-slot:cell(bet_count)="row")
                    span #[b {{ row.item.bet_count }} ]
                  template(v-slot:cell(turnover)="row")
                    span(:class="$helpers.getNumberClass(row.item.turnover)") #[b {{ row.item.turnover | currency }} ]
                  template(v-slot:cell(valid_turnover)="row")
                    span(:class="$helpers.getNumberClass(row.item.valid_turnover)") #[b {{ row.item.valid_turnover | currency }} ]
                  // template(v-slot:cell(gross_comm)="row")
                  //   span(:class="$helpers.getNumberClass(row.item.gross_comm)") #[b {{ row.item.gross_comm | currency }} ]
                  template(v-slot:thead-top="row")
                    tr
                      th.bg-grey-lighter(colspan="6")
                      th.text-center.bg-grey-transparent-1(colspan="1") {{ $t("ui.member") }}
                      // th.text-center.bg-grey-transparent-3(colspan="1") {{ $helpers.getUplineName(downlineLevel) }}
                      // th.text-center.bg-grey-transparent-5(colspan="3") {{ $t("ui.company") }}
                  template(v-slot:cell(member_winlose)="row")
                    span(:class="$helpers.getNumberClass(row.item.member_winlose)") #[b {{ row.item.member_winlose | currency }} ]
                  // template(v-slot:cell(member_comm)="row")
                  //   span(:class="$helpers.getNumberClass(row.item.member_comm)") #[b {{ row.item.member_comm | currency }} ]
                  // template(v-slot:cell(member_winlose_comm)="row")
                  //   span(:class="$helpers.getNumberClass(row.item.member_winlose_comm)") #[b {{ row.item.member_winlose_comm | currency }} ]
                  // template(v-slot:cell(agent_winlose)="row")
                  //   span(:class="$helpers.getNumberClass(row.item.agent_winlose)") #[b {{ row.item.agent_winlose | currency }} ]
                  // template(v-slot:cell(agent_comm)="row")
                  //   span(:class="$helpers.getNumberClass(row.item.agent_comm)") #[b {{ row.item.agent_comm | currency }} ]
                  // template(v-slot:cell(agent_winlose_comm)="row")
                  //   span(:class="$helpers.getNumberClass(row.item.agent_winlose_comm)") #[b {{ row.item.agent_winlose_comm | currency }} ]
                  // template(v-slot:cell(company_winlose)="row")
                  //   span(:class="$helpers.getNumberClass(row.item.company_winlose)") #[b {{ row.item.company_winlose | currency }} ]
                  // template(v-slot:cell(company_comm)="row")
                  //   span(:class="$helpers.getNumberClass(row.item.company_comm)") #[b {{ row.item.company_comm | currency }} ]
                  // template(v-slot:cell(company_winlose_comm)="row")
                  //   span(:class="$helpers.getNumberClass(row.item.company_winlose_comm)") #[b {{ row.item.company_winlose_comm | currency }} ]
                  template(v-slot:bottom-row="row" v-if="showTotal")
                    td.text-right(colspan="3")
                      span #[b {{ $t("ui.sub_total") }}]
                      br
                      span #[b {{ $t("ui.grand_total") }} ]
                    td.text-center
                      span #[b {{ subTotalBetCount }}]
                      br
                      span #[b {{ grandTotalBetCount }} ]
                    td.text-right
                      span(:class="$helpers.getNumberClass(subTotalTurnover)")  #[b {{ subTotalTurnover | currency }}]
                      br
                      span(:class="$helpers.getNumberClass(grandTotalTurnover)")  #[b {{ grandTotalTurnover | currency }} ]
                    td.text-right
                      span(:class="$helpers.getNumberClass(subTotalValidTurnover)")  #[b {{ subTotalValidTurnover | currency }}]
                      br
                      span(:class="$helpers.getNumberClass(grandTotalValidTurnover)")  #[b {{ grandTotalValidTurnover | currency }} ]
                    // td.text-right
                    //   span(:class="$helpers.getNumberClass(subTotalGrossCommission)")  #[b {{ subTotalGrossCommission | currency }}]
                    //   br
                    //   span(:class="$helpers.getNumberClass(grandTotalGrossCommission)")  #[b {{ grandTotalGrossCommission | currency }} ]
                    td.text-right
                      span(:class="$helpers.getNumberClass(subTotalMemberWinlose)")  #[b {{ subTotalMemberWinlose | currency }}]
                      br
                      span(:class="$helpers.getNumberClass(grandTotalMemberWinlose)")  #[b {{ grandTotalMemberWinlose | currency }} ]
                    // td.text-right
                    //   span(:class="$helpers.getNumberClass(subTotalMemberCommission)")  #[b {{ subTotalMemberCommission | currency }}]
                    //   br
                    //   span(:class="$helpers.getNumberClass(grandTotalMemberCommission)")  #[b {{ grandTotalMemberCommission | currency }} ]
                    // td.text-right.bg-yellow-transparent-2
                    //   span(:class="$helpers.getNumberClass(subTotalMemberWinloseCommission)")  #[b {{ subTotalMemberWinloseCommission | currency }}]
                    //   br
                    //   span(:class="$helpers.getNumberClass(grandTotalMemberWinloseCommission)")  #[b {{ grandTotalMemberWinloseCommission | currency }} ]
                    // td.text-right
                    //   span(:class="$helpers.getNumberClass(subTotalAgentWinlose)")  #[b {{ subTotalAgentWinlose | currency }}]
                    //   br
                    //   span(:class="$helpers.getNumberClass(grandTotalAgentWinlose)")  #[b {{ grandTotalAgentWinlose | currency }} ]
                    // td.text-right
                    //   span(:class="$helpers.getNumberClass(subTotalAgentCommission)")  #[b {{ subTotalAgentCommission | currency }}]
                    //   br
                    //   span(:class="$helpers.getNumberClass(grandTotalAgentCommission)")  #[b {{ grandTotalAgentCommission | currency }} ]
                    // td.text-right.bg-yellow-transparent-2
                    //   span(:class="$helpers.getNumberClass(subTotalAgentWinloseCommission)")  #[b {{ subTotalAgentWinloseCommission | currency }}]
                    //   br
                    //   span(:class="$helpers.getNumberClass(grandTotalAgentWinloseCommission)")  #[b {{ grandTotalAgentWinloseCommission | currency }} ]
                    // td.text-right
                    //   span(:class="$helpers.getNumberClass(subTotalCompanyWinlose)")  #[b {{ subTotalCompanyWinlose | currency }}]
                    //   br
                    //   span(:class="$helpers.getNumberClass(grandTotalCompanyWinlose)")  #[b {{ grandTotalCompanyWinlose | currency }} ]
                    // td.text-right
                    //   span(:class="$helpers.getNumberClass(subTotalCompanyCommission)")  #[b {{ subTotalCompanyCommission | currency }}]
                    //   br
                    //   span(:class="$helpers.getNumberClass(grandTotalCompanyCommission)")  #[b {{ grandTotalCompanyCommission | currency }} ]
                    // td.text-right.bg-yellow-transparent-2
                    //   span(:class="$helpers.getNumberClass(subTotalCompanyWinloseCommission)")  #[b {{ subTotalCompanyWinloseCommission | currency }}]
                    //   br
                    //   span(:class="$helpers.getNumberClass(grandTotalCompanyWinloseCommission)")  #[b {{ grandTotalCompanyWinloseCommission | currency }} ]
</template>

<script>
import config from "@/config";
import DebounceInput from "@/library/DebounceInput";
import SubmitButton from "@/library/SubmitButton.vue";
import DateRangePicker from "@/library/DateRangePicker.vue";
import DatePicker from "@/library/DatePicker.vue";
import jsonToExcel from "@/library/jsonToExcel.vue";

export default {
  components: {
    DebounceInput,
    SubmitButton,
    DateRangePicker,
    DatePicker,
    jsonToExcel
  },
  data() {
    return {
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      member_id: "",
      downlineLevel: 0,
      lines: [],
      dailyWinloseList: [],
      subTotalBetCount: 0,
      grandTotalBetCount: 0,
      subTotalTurnover: 0,
      grandTotalTurnover: 0,
      subTotalValidTurnover: 0,
      grandTotalValidTurnover: 0,
      subTotalGrossCommission: 0,
      grandTotalGrossCommission: 0,
      // member
      subTotalMemberWinlose: 0,
      grandTotalMemberWinlose: 0,
      subTotalMemberCommission: 0,
      grandTotalMemberCommission: 0,
      subTotalMemberWinloseCommission: 0,
      grandTotalMemberWinloseCommission: 0,
      // agent / current login level
      subTotalAgentWinlose: 0,
      grandTotalAgentWinlose: 0,
      subTotalAgentCommission: 0,
      grandTotalAgentCommission: 0,
      subTotalAgentWinloseCommission: 0,
      grandTotalAgentWinloseCommission: 0,
      // company
      subTotalCompanyWinlose: 0,
      grandTotalCompanyWinlose: 0,
      subTotalCompanyCommission: 0,
      grandTotalCompanyCommission: 0,
      subTotalCompanyWinloseCommission: 0,
      grandTotalCompanyWinloseCommission: 0,
      showTotal: false,
      filter: null,
      sortBy: "account_id",
      sortDesc: false,
      currentPage: 1,
      totalRows: 0
    };
  },
  validations: {},
  computed: {
    dateRange() {
      return {
        startDate: this.$moment(this.$store.getters.dateRange.startDate).format("YYYY-MM-DD"),
        endDate: this.$moment(this.$store.getters.dateRange.endDate).format("YYYY-MM-DD")
      }
    },
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "bg-grey-lighter",
          thStyle: {
            width: "3%"
          }
        },
        {
          key: "account_id",
          label: this.$t("ui.account_id"),
          class: "align-middle",
          thClass: "bg-grey-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "full_name",
          label: this.$t("ui.full_name"),
          class: "align-middle",
          thClass: "bg-grey-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "bet_count",
          label: this.$t("ui.bet_count"),
          class: "align-middle text-center",
          thClass: "bg-grey-lighter",
          thStyle: {
            width: "6%"
          }
        },
        {
          key: "turnover",
          label: this.$t("ui.turnover"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "bg-grey-lighter",
          thStyle: {
            width: "7%"
          }
        },
        {
          key: "valid_turnover",
          label: this.$t("ui.valid_turnover"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "bg-grey-lighter",
          thStyle: {
            width: "7%"
          }
        },
        // {
        //   key: "gross_comm",
        //   label: this.$t("ui.gross_commission"),
        //   sortable: true,
        //   class: "align-middle text-right",
        //   thClass: "bg-grey-lighter",
        //   thStyle: {
        //     width: "7%"
        //   }
        // },
        {
          key: "member_winlose",
          label: this.$t("ui.winlose_column1"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "bg-grey-transparent-1",
          thStyle: {
            width: "9%"
          }
        },
        // {
        //   key: "member_comm",
        //   label: this.$t("ui.winlose_column2"),
        //   sortable: true,
        //   class: "align-middle text-right",
        //   thClass: "bg-grey-transparent-1",
        //   thStyle: {
        //     width: "7%"
        //   }
        // },
        // {
        //   key: "member_winlose_comm",
        //   label: this.$t("ui.total"),
        //   sortable: true,
        //   class: "align-middle text-right bg-yellow-transparent-2",
        //   thClass: "bg-yellow-transparent-2",
        //   thStyle: {
        //     width: "7%"
        //   }
        // },
        // {
        //   key: "agent_winlose",
        //   label: this.$t("ui.winlose_column1"),
        //   sortable: true,
        //   class: "align-middle text-right",
        //   thClass: "bg-grey-transparent-3",
        //   thStyle: {
        //     width: "21%"
        //   }
        // },
        // {
        //   key: "agent_comm",
        //   label: this.$t("ui.winlose_column2"),
        //   sortable: true,
        //   class: "align-middle text-right",
        //   thClass: "bg-grey-transparent-3",
        //   thStyle: {
        //     width: "7%"
        //   }
        // },
        // {
        //   key: "agent_winlose_comm",
        //   label: this.$t("ui.total"),
        //   sortable: true,
        //   class: "align-middle text-right bg-yellow-transparent-2",
        //   thClass: "bg-yellow-transparent-2",
        //   thStyle: {
        //     width: "7%"
        //   }
        // },
        // {
        //   key: "company_winlose",
        //   label: this.$t("ui.winlose_column1"),
        //   sortable: true,
        //   class: "align-middle text-right",
        //   thClass: "bg-grey-transparent-5",
        //   thStyle: {
        //     width: "7%"
        //   }
        // },
        // {
        //   key: "company_comm",
        //   label: this.$t("ui.winlose_column2"),
        //   sortable: true,
        //   class: "align-middle text-right",
        //   thClass: "bg-grey-transparent-5",
        //   thStyle: {
        //     width: "7%"
        //   }
        // },
        // {
        //   key: "company_winlose_comm",
        //   label: this.$t("ui.total"),
        //   sortable: true,
        //   class: "align-middle text-right bg-yellow-transparent-2",
        //   thClass: "bg-yellow-transparent-2",
        //   thStyle: {
        //     width: "7%"
        //   }
        // }
      ]
    },
    perPage() {
      return this.$store.getters.pageSize
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC"
    }
  },
  watch: {
  },
  mounted: function() {
    this.$store.dispatch("user/setSelectedID", this.$store.getters.accountID)
    //this.member_id = this.$store.getters.getSelectedID;
    this.submit()
  },
  methods: {
    drillIn: function(account_id) {
      this.$store.dispatch("user/setSelectedID", account_id)
      this.submit()
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize)
      this.currentPage = 1
      this.submit()
    },
    sortingChanged(ctx) {
      if (ctx.sortBy !== this.sortBy) {
        this.sortDesc = false
      } else {
        this.sortDesc = this.direction === "ASC"
      }

      this.sortBy = ctx.sortBy
      this.submit()
      this.refreshTable("tblList")
    },
    refreshTable(table) {
      this.$root.$emit("bv::table::refresh", table)
    },
    submit: function() {
      if (!this.$v.$invalid) {
        let url = config.getDailyWinloseTournamentUrl()
        let target_id = this.$store.getters.getSelectedID
        //let target_id = this.$store.getters.accountID
        let search_id = this.member_id
        let start_date = this.dateRange.startDate
        let end_date = this.dateRange.endDate
        let page_number = this.currentPage
        this.currentPage = parseInt(page_number)
        let page_size = this.perPage
        let sort_key = this.sortBy
        let sort_type = this.direction
        this.loading = true
        this.$store
          .dispatch("user/getDailyWinlose", { url, target_id, search_id, start_date, end_date, page_number, page_size, sort_key, sort_type })
          .then(response => {
            this.clearTotal()
            this.loading = false
            this.submission.success = response.success
            this.submission.status = response.errorTag
            if (this.submission.success == true) {
              this.lines = response.line
              this.downlineLevel = this.lines[this.lines.length-1].account_type

              if(response.data.length > 0) {
                this.showTotal = true

                this.dailyWinloseList = response.data
                this.totalRows = response.data.length > 0 ? this.dailyWinloseList[0]["totalrows"] : 0

                response.data.forEach(value => {
                  this.subTotalBetCount = this.subTotalBetCount + value["bet_count"];
                  this.subTotalTurnover = parseFloat(this.subTotalTurnover) + parseFloat(value["turnover"]);
                  this.subTotalValidTurnover = parseFloat(this.subTotalValidTurnover) + parseFloat(value["valid_turnover"]);
                  this.subTotalGrossCommission = parseFloat(this.subTotalGrossCommission) + parseFloat(value["gross_comm"]);

                  this.subTotalMemberWinlose = parseFloat(this.subTotalMemberWinlose) + parseFloat(value["member_winlose"]);
                  this.subTotalMemberCommission = parseFloat(this.subTotalMemberCommission) + parseFloat(value["member_comm"]);
                  this.subTotalMemberWinloseCommission = parseFloat(this.subTotalMemberWinloseCommission) + parseFloat(value["member_winlose_comm"]);

                  this.subTotalAgentWinlose = parseFloat(this.subTotalAgentWinlose) + parseFloat(value["agent_winlose"]);
                  this.subTotalAgentCommission = parseFloat(this.subTotalAgentCommission) + parseFloat(value["agent_comm"]);
                  this.subTotalAgentWinloseCommission = parseFloat(this.subTotalAgentWinloseCommission) + parseFloat(value["agent_winlose_comm"]);

                  this.subTotalCompanyWinlose = parseFloat(this.subTotalCompanyWinlose) + parseFloat(value["company_winlose"]);
                  this.subTotalCompanyCommission = parseFloat(this.subTotalCompanyCommission) + parseFloat(value["company_comm"]);
                  this.subTotalCompanyWinloseCommission = parseFloat(this.subTotalCompanyWinloseCommission) + parseFloat(value["company_winlose_comm"]);
                })

                if(response.grandTotal.length > 0) {
                  this.grandTotalBetCount = response.grandTotal[0]["bet_count"];
                  this.grandTotalTurnover = response.grandTotal[0]["turnover"];
                  this.grandTotalValidTurnover = response.grandTotal[0]["valid_turnover"];
                  this.grandTotalGrossCommission = response.grandTotal[0]["gross_comm"];

                  this.grandTotalMemberWinlose = response.grandTotal[0]["member_winlose"];
                  this.grandTotalMemberCommission = response.grandTotal[0]["member_comm"];
                  this.grandTotalMemberWinloseCommission = response.grandTotal[0]["member_winlose_comm"];

                  this.grandTotalAgentWinlose = response.grandTotal[0]["agent_winlose"];
                  this.grandTotalAgentCommission = response.grandTotal[0]["agent_comm"];
                  this.grandTotalAgentWinloseCommission = response.grandTotal[0]["agent_winlose_comm"];

                  this.grandTotalCompanyWinlose = response.grandTotal[0]["company_winlose"];
                  this.grandTotalCompanyCommission = response.grandTotal[0]["company_comm"];
                  this.grandTotalCompanyWinloseCommission = response.grandTotal[0]["company_winlose_comm"];
                }
              } else {
                this.clearTotal()
              }
            } else {
              this.loading = false
              this.submission.success = response.success
              this.submission.status = response.errorTag
            }
          })
          .catch(response => {
            this.loading = false
            this.clearTotal()
            this.submission.success = response.success
            this.submission.status = this.$t("message." + response.errorTag)
          });
      }
    },
    clearTotal() {
      this.showTotal = false
      this.dailyWinloseList = []
      this.lines = []
      this.totalRows = 0
      this.subTotalBetCount = 0
      this.grandTotalBetCount = 0
      this.subTotalTurnover = 0
      this.grandTotalTurnover = 0
      this.subTotalValidTurnover = 0
      this.grandTotalValidTurnover = 0
      this.subTotalGrossCommission = 0
      this.grandTotalGrossCommission = 0
      this.subTotalMemberWinlose = 0
      this.grandTotalMemberWinlose = 0
      this.subTotalMemberCommission = 0
      this.grandTotalMemberCommission = 0
      this.subTotalMemberWinloseCommission = 0
      this.grandTotalMemberWinloseCommission = 0
      this.subTotalAgentWinlose = 0
      this.grandTotalAgentWinlose = 0
      this.subTotalAgentCommission = 0
      this.grandTotalAgentCommission = 0
      this.subTotalAgentWinloseCommission = 0
      this.grandTotalAgentWinloseCommission = 0
      this.subTotalCompanyWinlose = 0
      this.grandTotalCompanyWinlose = 0
      this.subTotalCompanyCommission = 0
      this.grandTotalCompanyCommission = 0
      this.subTotalCompanyWinloseCommission = 0
      this.grandTotalCompanyWinloseCommission = 0
    }
  }
};
</script>
